// Generated from src/game/gamble.ts; run node tools/gen-gamble.mjs --write.
import { GRADES, SHOP_MAX_GRADE } from "./map.js";
export const GAMBLE_PRICE = 500000;
export const GAMBLE_PICKS = 1;
export const GAMBLE_TARGET_EDGE = 0.15;
export const GAMBLE_POOL = GRADES.filter((g) => g.id <= SHOP_MAX_GRADE);
export const GAMBLE_D = 0.6;
export const GAMBLE_CENTER = Math.floor((GAMBLE_POOL.length - 1) / 2);
export const GAMBLE_DIST = (() => {
    const w = GAMBLE_POOL.map((_, i) => GAMBLE_D ** Math.abs(i - GAMBLE_CENTER));
    const sum = w.reduce((a, b) => a + b, 0);
    return w.map((x) => x / sum);
})();
export function rollGrade(r) {
    let acc = 0;
    for (let i = 0; i < GAMBLE_POOL.length; i++) {
        acc += GAMBLE_DIST[i];
        if (r < acc)
            return GAMBLE_POOL[i].id;
    }
    return GAMBLE_POOL[GAMBLE_POOL.length - 1].id;
}
